import React from "react";
import { Link } from "react-router-dom";

function HomeScreenPopularImageTools() {
  return (
    <div className="container text-center">
      {/* Title */}
      <div style={{ marginTop: "5rem" }}>
        <label className="display-6 fw-bold text-dark">
          Your Favourite Image Tools
        </label>
      </div>

      <div className=" mt-2">
        <label className="fs-6">
          Free image tools. No Download. Edit Online/Offline.
        </label>
      </div>

      {/* Popular Tools grid */}
      <div className="mt-5">
        <div className="row g-2">

          {/* Image Compressor */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/image_resizer"
              state={{ title: "Compress Images & Resize Images Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Compress Images</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Reduce size of images without losing quality.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Crop Image */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/crop_image"
              state={{ title: "Trim & Crop Image For Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Trim & Crop Image</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Crop JPG, PNG or GIF by defining a rectangle in pixels.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Rotate Image */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/flip_image"
              state={{ title: "Rotate & Flip Images For Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Rotate & Flip Image</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Batch rotate & flip images. Flip your image horizontally or vertically.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Image Converter */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/image_converter"
              state={{ title: "Convert & Edit Images For Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Image Converter</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Convert images from JPG to PNG, PNG to JPG, JPG to WEBP etc.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Merge Images */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/merge_images"
              state={{ title: "Merge & Join Images For Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Image Merger</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Merge two or more images vertically or horizontally to create a new image.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Split Image */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/split_image"
              state={{ title: "Split Image Into Parts For Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Image Splitter</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Split an image horizontally, vertically or both.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Watermark Image */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/watermark_image"
              state={{ title: "Bulk Watermark Images For Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Watermark Image</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Protect your digital images with custom watermarks.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Image Resizer */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/image_resizer"
              state={{ title: "Image Resizer & Image Compressor Free" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Image Resizer</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Resize and compress images under 200KB.
                  </p>
                </div>
              </div>
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default HomeScreenPopularImageTools;
